// extracted by mini-css-extract-plugin
module.exports = {"dataNascimento":"ClienteInformacao_dataNascimento__X5jaO","profissao":"ClienteInformacao_profissao__3viAC"};